export default {
  showEditor : function($target) {
    var $show = $target.closest('.row.show-profile').hide();
    var $edit = $show.next('.row.edit-profile').show();
  },
  showLastEditor : function($parent) {
    $parent.find('.row.edit-profile').last().show();
  },
  hideEditor : function($target) {
    var $edit = $target.closest('.row.edit-profile').hide();
    var $show = $edit.prev('.row.show-profile').show();
  },
  updateCollection : function(collection, newItem) {
    var matchedItem = ko.utils.arrayFirst(collection(), function(item) {
      if (item.id() === newItem.id()) {
        return item;
      }
    });

    if (matchedItem) {
      collection.replace(matchedItem, newItem);
    } else {
      collection.push(newItem);
    }
  },
  initDropZones: function($parent, collection){
    var $elements = $parent.find('.js-dz-profile-img');

    $.each($elements, function(index, el) {
      var $el = $(el);
      var $editor = $el.parent().parent();
      var id = $el.attr('data-id') ? $el.attr('data-id') : '';
      var model_name = $parent.attr('id') === 'guest_lecturers' ? $parent.attr('id') : 'instructors';
      var param_name = model_name.slice(0, -1) + '[avatar]';
      var url = (model_name === 'guest_lecturers' ? window.location.pathname.replace('instructors', model_name) : window.location.pathname) + '/' + id;

      var $imageInput = $el.find('input[name=\'full\']');
      var $thumbInput = $el.find('input[name=\'thumb\']');

      var message = JST['templates/dropzone-imagefile']({
        message: Kadenze.I18n.t('instructor.image.dropzone.add_image'),
        subMessage: Kadenze.I18n.t('instructor.image.dropzone.max_file_size'),
        dimensions: Kadenze.I18n.t('instructor.image.dropzone.dimensions'),
      });
      message = Kadenze.I18n.tt(message, 'en');

      var curFileObj;
      if ($imageInput.length > 0) {
        var imgPath = ( $imageInput.val() )? $thumbInput.val() : '';
        curFileObj = {
          path: imgPath
        };
      }

      var options = {
        method: id ? 'PUT' : 'POST',
        autoProcessQueue: id ? true : false,
        paramName: param_name
      };

      try { if(Dropzone.forElement('#' + $el.attr('id'))) { return; } }
      catch(err) { }

      // callbacks are setup in savelecturer
      var callbacks = { };
      var profileDZ = new Kadenze.ImageDropZone($el, message, url, callbacks, curFileObj, options );
    });
  },
};

